(function () {
    // ========================================================
    // LANGUAGE & CURRENCY SELECTOR - Babysensor
    // Uses localStorage to persist language selection.
    //
    // On .no domain: selecting a non-NOK currency redirects to
    // .com with the current language preserved via URL prefix
    // and ?set_country=XX query param.
    // On .com domain: currency form submits natively.
    // ========================================================

    const STORAGE_KEY = 'babysensor_selected_language';

    const langDisplayNames = {
        'en': 'ENG', 'no': 'NOR', 'nb': 'NOR',
        'de': 'DE', 'fr': 'FR', 'it': 'IT', 'es': 'ES',
        'nl': 'NL', 'pl': 'PL', 'sv': 'SV', 'da': 'DA',
        'ca': 'CA', 'pt': 'PT', 'fi': 'FI', 'cs': 'CS'
    };

    function saveLanguage(langCode) {
        try { localStorage.setItem(STORAGE_KEY, langCode); } catch (e) {}
    }

    function getSavedLanguage() {
        try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    }

    function getLanguageFromUrl() {
        const match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
        if (match) return match[1].split('-')[0].toLowerCase();
        return null;
    }

    function getDisplayName(langCode) {
        if (!langCode) return 'ENG';
        return langDisplayNames[langCode.toLowerCase()] || langCode.toUpperCase();
    }

    // Determine current language from URL (most reliable) or localStorage (fallback)
    // Saves to localStorage so the trigger button stays consistent
    function getCurrentLanguage() {
        const urlLang = getLanguageFromUrl();
        if (urlLang) {
            saveLanguage(urlLang);
            return urlLang;
        }
        // No language prefix in URL = default language (en)
        // Save 'en' so localStorage stays in sync with actual page language
        saveLanguage('en');
        return 'en';
    }

    function isPrimaryDomain() {
        const h = window.location.hostname;
        return h.includes('.com') || h.includes('localhost') || h.includes('127.0.0.1');
    }

    // Get the primary .com domain from the current hostname
    // e.g. babysensor.no -> babysensor.com
    function getPrimaryDomain() {
        const h = window.location.hostname;
        if (h.includes('.com') || h.includes('localhost')) return h;
        return h.replace(/\.[^.]+$/, '.com');
    }

    // Get current path without language prefix
    function getCleanPath() {
        let path = window.location.pathname;
        path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(\/|$)/i, '$1');
        if (!path.startsWith('/')) path = '/' + path;
        if (!path) path = '/';
        return path;
    }

    // ---- On page load: handle cross-domain currency change ----
    //
    // When arriving from .no with ?set_country=XX&set_lang=YY:
    //   1. Save language to localStorage
    //   2. Clean the address bar (cosmetic, via replaceState)
    //   3. Submit the currency form with return_to = clean path
    //      → Shopify processes the country change
    //      → Shopify redirects to our return_to (clean URL, no params)
    //      → No loop because the clean URL has no set_country param
    //
    (function handleCrossDomainParams() {
        var params = new URLSearchParams(window.location.search);
        var countryCode = params.get('set_country');
        var setLang = params.get('set_lang');

        if (!countryCode) return;

        // Save language to this domain's localStorage
        if (setLang) saveLanguage(setLang);

        // Build the clean return path (current path without our custom params)
        params.delete('set_country');
        params.delete('set_lang');
        var cleanSearch = params.toString() ? '?' + params.toString() : '';
        var cleanReturn = window.location.pathname + cleanSearch;

        // Clean the address bar immediately (cosmetic only)
        try {
            window.history.replaceState({}, '', cleanReturn + window.location.hash);
        } catch (e) {}

        // Submit the currency form directly with return_to for a clean redirect
        function submitCurrencyForm() {
            var form = document.querySelector('#CustomCurrencyForm');
            if (!form) return;

            var radio = form.querySelector('input[name="country_code"][value="' + countryCode + '"]');
            if (!radio) return;

            radio.checked = true;

            // Inject return_to so Shopify redirects to the clean URL
            // (instead of using the HTTP Referer, which may still carry params)
            var returnTo = form.querySelector('input[name="return_to"]');
            if (!returnTo) {
                returnTo = document.createElement('input');
                returnTo.type = 'hidden';
                returnTo.name = 'return_to';
                form.appendChild(returnTo);
            }
            returnTo.value = cleanReturn;
            form.submit();
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', submitCurrencyForm);
        } else {
            setTimeout(submitCurrencyForm, 100);
        }
    })();

    // ---- Set up triggers and panels ----
    const triggers = document.querySelectorAll('.custom-lang-currency-trigger');
    const panels = document.querySelectorAll('.custom-lang-currency-panel');

    triggers.forEach((trigger, index) => {
        const panel = panels[index];
        if (!trigger || !panel) return;

        const wrapper = trigger.closest('.custom-lang-currency-wrapper');
        const panelClose = panel.querySelector('.panel-close');
        const panelOverlay = panel.querySelector('.panel-overlay');
        const weglotLanguageList = panel.querySelector('.weglot-language-list');
        const currentLangDisplay = trigger.querySelector('#current-lang-display');

        const currentLang = getCurrentLanguage();
        if (currentLangDisplay) {
            currentLangDisplay.textContent = getDisplayName(currentLang);
        }

        // Update active state for Shopify language buttons
        const shopifyLangButtons = panel.querySelectorAll('.shopify-lang-link');
        shopifyLangButtons.forEach(btn => {
            const btnLang = btn.getAttribute('data-lang');
            btn.classList.remove('active');
            if (btnLang === currentLang || (currentLang === 'nb' && btnLang === 'no') || (currentLang === 'no' && btnLang === 'nb')) {
                btn.classList.add('active');
            }
        });

        // ---- Scroll lock ----
        let scrollPosition = 0;

        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPosition}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            if (scrollbarWidth > 0) {
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            }
            panel.classList.add('active');
        });

        function closePanel() {
            panel.classList.remove('active');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            window.scrollTo(0, scrollPosition);
        }

        if (panelClose) panelClose.addEventListener('click', closePanel);
        if (panelOverlay) panelOverlay.addEventListener('click', closePanel);
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && panel.classList.contains('active')) {
                closePanel();
            }
        });

        // ---- Shopify Language Form ----
        const shopifyLanguageForm = panel.querySelector('#HeaderLanguageFormCustom');
        if (shopifyLanguageForm) {
            shopifyLanguageForm.addEventListener('submit', function (e) {
                const submitter = e.submitter;
                if (submitter) {
                    const langCode = submitter.getAttribute('data-lang') || submitter.value;
                    if (langCode) {
                        saveLanguage(langCode);
                        if (currentLangDisplay) {
                            currentLangDisplay.textContent = getDisplayName(langCode);
                        }
                    }
                }
                closePanel();
            });
        }

        // ---- Currency Form ----
        const currencyForm = panel.querySelector('#CustomCurrencyForm');
        if (currencyForm) {
            const currencyInputs = currencyForm.querySelectorAll('input[type="radio"]');

            currencyInputs.forEach(input => {
                input.addEventListener('change', function () {
                    if (!this.checked) return;

                    // Update visual state
                    panel.querySelectorAll('.currency-column .option-item').forEach(item => {
                        item.classList.remove('selected');
                    });
                    this.closest('.option-item').classList.add('selected');

                    const countryCode = this.value;
                    const selectedCurrency = this.closest('.option-item').getAttribute('data-currency-code');
                    const currentCurrency = wrapper ? wrapper.getAttribute('data-current-currency') : '';

                    closePanel();

                    if (isPrimaryDomain()) {
                        // On .com: submit form natively with return_to for clean redirect
                        var returnTo = currencyForm.querySelector('input[name="return_to"]');
                        if (!returnTo) {
                            returnTo = document.createElement('input');
                            returnTo.type = 'hidden';
                            returnTo.name = 'return_to';
                            currencyForm.appendChild(returnTo);
                        }
                        returnTo.value = window.location.pathname;
                        currencyForm.submit();
                    } else {
                        // On .no (or other market domain):
                        // If selecting the same currency (NOK), do nothing
                        if (selectedCurrency === currentCurrency) return;

                        // Redirect to .com with language preserved + set_country & set_lang params
                        const lang = getCurrentLanguage();
                        const cleanPath = getCleanPath();
                        const primaryDomain = getPrimaryDomain();
                        const protocol = window.location.protocol;

                        // Build .com URL: https://babysensor.com/{lang}/path?set_country=XX&set_lang=YY
                        let langPrefix = '';
                        if (lang && lang !== 'en') {
                            langPrefix = '/' + lang;
                        }
                        const targetPath = langPrefix + cleanPath;
                        const targetUrl = protocol + '//' + primaryDomain + targetPath
                            + '?set_country=' + countryCode
                            + '&set_lang=' + lang;

                        window.location.href = targetUrl;
                    }
                });
            });
        }

        // ---- Weglot Language Extraction ----
        function extractWeglotLanguages() {
            const weglotSwitcher = document.querySelector('.weglot-container[data-switcher-id="1"]');
            if (!weglotSwitcher || !weglotLanguageList) return false;

            const languageOptions = weglotSwitcher.querySelectorAll('.language-list .language-option a');
            const activeLanguage = weglotSwitcher.querySelector('.active-language a');
            const allLanguages = [];

            const shopifyLanguages = [];
            panel.querySelectorAll('.shopify-lang-link').forEach(link => {
                const code = link.getAttribute('data-lang');
                if (code) shopifyLanguages.push(code.toLowerCase());
            });

            if (activeLanguage) {
                const langCode = activeLanguage.getAttribute('lang') || activeLanguage.textContent.trim().toLowerCase();
                if (!shopifyLanguages.includes(langCode)) {
                    allLanguages.push({ code: langCode.toUpperCase(), lang: langCode });
                }
            }

            languageOptions.forEach(link => {
                const langCode = link.getAttribute('lang') || link.textContent.trim().toLowerCase();
                if (!shopifyLanguages.includes(langCode) && !allLanguages.find(l => l.lang === langCode)) {
                    allLanguages.push({ code: langCode.toUpperCase(), lang: langCode });
                }
            });

            if (allLanguages.length === 0) return false;

            const languageNames = {
                'de': 'Deutsch', 'fr': 'Français', 'it': 'Italiano',
                'es': 'Español', 'nl': 'Nederlands', 'pl': 'Polski',
                'sv': 'Svenska', 'da': 'Dansk', 'ca': 'Català',
                'pt': 'Português', 'fi': 'Suomi', 'cs': 'Čeština'
            };

            let html = '';
            allLanguages.forEach(lang => {
                const name = languageNames[lang.lang] || lang.code;
                const active = currentLang === lang.lang ? 'active' : '';
                html += `<a href="#" class="language-option-custom weglot-link ${active}" data-lang="${lang.lang}">
                    <span class="option-name">${name}</span>
                    <span class="option-code">${lang.code}</span>
                </a>`;
            });

            weglotLanguageList.innerHTML = html;

            weglotLanguageList.querySelectorAll('.weglot-link').forEach(link => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    const langCode = this.getAttribute('data-lang');
                    saveLanguage(langCode);
                    if (currentLangDisplay) {
                        currentLangDisplay.textContent = getDisplayName(langCode);
                    }
                    let path = window.location.pathname;
                    path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(\/|$)/i, '$1');
                    if (!path.startsWith('/')) path = '/' + path;
                    if (!path) path = '/';
                    const targetPath = path === '/' ? '/' + langCode : '/' + langCode + path;
                    window.location.href = window.location.origin + targetPath;
                });
            });

            return true;
        }

        let attempts = 0;
        function tryExtractLanguages() {
            if (extractWeglotLanguages()) {
                // done
            } else if (attempts < 10) {
                attempts++;
                setTimeout(tryExtractLanguages, 500);
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', tryExtractLanguages);
        } else {
            tryExtractLanguages();
        }
    });

    // NOTE: No auto-redirect on page load.
    // Shopify handles language routing natively via the localization form.
    // localStorage is used only for:
    //   1. Showing the correct language in the trigger button
    //   2. Passing language cross-domain (.no -> .com via set_lang param)
})();
